import React from "react";
import { Box, Typography, Container, Grid, Button } from "@mui/material";
import "./AccountSettings.css";
import { useNavigate } from "react-router-dom";

const AccountSettings = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography variant="h4" fontWeight="bold" textAlign="center" mb={4}>
          Manage Your TA Wallet Account Settings
        </Typography>
        <Button color="inherit" onClick={() => navigate("/helpcenterlayout")}>
          Back to Home
        </Button>
      </Box>

      {/* Section 1 */}
      <Grid container spacing={4} alignItems="center" mb={6}>
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Stay in Control
          </Typography>
          <Typography variant="body1" paragraph>
            Keeping your wallet secure starts with staying in control of your
            account settings. From this panel, you can view and edit your
            profile information, update your contact details, and ensure that
            your personal data is accurate and up to date.
          </Typography>
          <Typography variant="body1">
            This not only improves your overall user experience but also ensures
            you receive important alerts, notifications, and promotional offers
            from TA Wallet directly and securely.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <img
            src="/Assets/tasetting.jpg"
            alt="Wallet Settings"
            className="animated-image"
            style={{ width: "100%", borderRadius: 12 }}
          />
        </Grid>
      </Grid>

      {/* Section 2 */}
      <Grid container spacing={4} alignItems="center" mb={6}>
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <Box className="task-image-wrapper">
            <img
              src="/Assets/taseetings2.png"
              alt="Multitasking Illustration"
              className="rotating-image"
              style={{ width: "100%", maxHeight: 420 }}
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Update with Confidence
          </Typography>
          <Typography variant="body1" paragraph>
            Handle everything with ease – from updating your bank details to
            checking KYC status and initiating wallet closure. You are in full
            control of your TA Wallet functionalities.
          </Typography>
          <Typography variant="body1">
            With intuitive controls and secure authentication, every task is
            simple, safe, and seamless. Our systems ensure that your actions are
            verified and protected using industry-standard encryption.
          </Typography>
        </Grid>
      </Grid>

      {/* Section 3 */}
      <Grid container spacing={4} alignItems="center">
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Enhanced Protection
          </Typography>
          <Typography variant="body1" paragraph>
            Your account is protected with features like TPIN for high-value
            transactions, two-factor authentication for logins, and real-time
            notifications for every activity. You also have full control over
            when and how you receive alerts.
          </Typography>
          <Typography variant="body1">
            We strongly recommend setting a secure TPIN and updating your login
            password regularly. These small habits drastically reduce the
            chances of unauthorized access and fraudulent activity in your
            wallet.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
          <img
            src="/Assets/tasettings3.jpg"
            alt="Account Security"
            className="animated-image2"
            style={{ width: "100%", borderRadius: 12 }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default AccountSettings;
